import type { ActivationGroup } from '@/features/activationGroup/types'
import type { ExtendedBid } from '@/features/bidding/types/bid'

/**
 * Returns DRAFT or OFFERED bids that match the provided activation groups.
 *
 * @param bids - The list of bids to filter.
 * @param activationGroups - The list of activation groups to match against.
 * @returns Only DRAFT or OFFERED bids that have an activation group UUID matching one of the provided activation groups.
 */
export function getDraftOrOfferedBidsMatchingActivationGroups(
  bids: ExtendedBid[],
  activationGroups: ActivationGroup[],
): ExtendedBid[] {
  if (!bids || !activationGroups) {
    return []
  }

  const activationGroupUuids = new Set(activationGroups.map((ag) => ag.uuid))
  return bids.filter(
    (bid) => (bid.status === 'DRAFT' || bid.status == 'OFFERED') && activationGroupUuids.has(bid.activationGroupUuid),
  )
}
